import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Clients from "@/components/site/Clients";
import Capabilities from "@/components/site/Capabilities";
import Standard from "@/components/site/Standard";
import Work from "@/components/site/Work";
import Principles from "@/components/site/Principles";
import Studio from "@/components/site/Studio";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative bg-obsidian">
      <Navbar />
      <Hero />
      <Clients />
      <Capabilities />
      <Standard />
      <Work />
      <Principles />
      <Studio />
      <Contact />
      <Footer />
    </main>
  );
}
